import { automationIdSelector } from 'automations/selectors/automationConfig';
import { useSelector } from 'react-redux';

export default function useAutomationId(): string {
  const automationId = useSelector(automationIdSelector);

  return automationId!;
}
